module.exports = __webpack_public_path__ + "img/benben tsukumo_sc1.b93e3fd7.png";